let deferredPrompt = null;
const listeners = new Set();

function notifyListeners() {
  const available = Boolean(deferredPrompt);
  listeners.forEach((listener) => {
    try {
      listener(available);
    } catch (error) {
      console.error('Install prompt listener failed:', error);
    }
  });
}

export function initializeInstallPrompt() {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;
    notifyListeners();
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notifyListeners();
  });
}

export function hasInstallPrompt() {
  return Boolean(deferredPrompt);
}

export async function promptInstall() {
  if (!deferredPrompt) {
    return { outcome: 'unavailable' };
  }

  const promptEvent = deferredPrompt;
  deferredPrompt = null;
  notifyListeners();

  await promptEvent.prompt();
  const choiceResult = await promptEvent.userChoice;

  return {
    outcome: choiceResult.outcome,
    platform: choiceResult.platform || null,
  };
}

export function onInstallPromptChange(listener) {
  listeners.add(listener);
  listener(Boolean(deferredPrompt));

  return () => {
    listeners.delete(listener);
  };
}
